import { defineAsyncComponent } from 'vue'

const localMap = {
    fusebeads: () => import('./fusebeads.vue'),
    littlebrick: () => import('./littlebrick.vue'),
    romantic: () => import('./romantic.vue'),
    diamondpainting: () => import('./diamondpainting.vue'),
    colorbrick_gray: () => import('./color_gray.vue'),
    colorbrick_orange: () => import('./color_orange.vue'),
    colorbrick_pink: () => import('./color_pink.vue'),
    microbrick: () => import('./microbrick.vue'),
    warmth: () => import('./warmth.vue'),
    origin: () => import('./littlebrick.vue'),
    memory: () => import('./color_gray.vue'),
    energetic: () => import('./color_orange.vue'),
    fascinatic: () => import('./color_pink.vue')
}

function normalizeKey(key) {
    if (!key) {
        return ''
    }
    const trimmed = key.toString().trim()
    return trimmed.toLowerCase()
}

export function loadCustomComponent(key) {
    const normalized = normalizeKey(key)
    if (!normalized) {
        return null
    }
    const loader = localMap[normalized]
    if (!loader) {
        if (key && key.toString().trim().startsWith('remote:')) {
            console.warn('[customLoader] remote component support is pending configuration', key)
        }
        return null
    }
    return defineAsyncComponent(loader)
}
